import { FollowCardMessage } from 'components/Dialogue';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { memo } from 'react';

export const FollowMsg = memo((props: BaseMsgProps) => {
  const { conversation } = props;
  const { topBarInfo } = conversation;

  return (
    <MessageExtendComplex
      {...props}
      content={<FollowCardMessage storeName={topBarInfo?.storeAlias || topBarInfo?.storeName} />}
    />
  );
});
